import React, { Component } from 'react'

export default class Administration extends Component {

  render() {
    return (
        <div>
          <div className="insid-header activity-header" style={{marginTop: '100px'}}>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="insid-header-text activity-header-text">
                    <h1 className="wow fadeIn" data-wow-duration=".2s" data-wow-delay=".1s">
                      Amministrazione e Bilancio
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section className="activity about2">
            <div className="container">
              <div className="row">
                <div className="col-sm-12 col-lg-12">
                  <div className="activity-text wow fadeIn animated" data-wow-duration=".5s" data-wow-delay=".2s">
                    <h2 className="activity-h2">Dettagli</h2>
                    <ul>
                      <li>Valutazione dell’<b>organizzazione</b> amministrativa e check-up del sistema contabile.</li>
                      <li>Gestione pro-tempore ruolo di CFO e Responsabile Amministrativo.</li>
                      <li>Assistenza nell’implementazione di sistemi amministrativi evoluti in grado di integrare le esigenze di natura societaria nei confronti dei terzi (azionisti, fisco, banche) con le esigenze di natura informativa del management, ai vari livelli della struttura organizzativa (contabilità generale e gestionale).</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )
  }
}



// WEBPACK FOOTER //
// ./src/pages/administration.it.js